import { Button, TextField } from '@mui/material'
import React,{ useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function Signup() {
  const [data, setData] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    class: "",
    pic: "",
    pymstatus: "",
    password: "",
    cfrpassword: "",

  })
  const navigate = useNavigate();
  function getData(e) {
    const name = e.target.name
    const value = e.target.value
    setData((old) => {
      return {
        ...old,
        [name]: value
      }
    })
  }
  async function postData(e) {
    e.preventDefault()
    if (data.password === data.cfrpassword) {
      const item = {
        name: data.name,
        mobile: data.mobile,
        email: data.email,
        address: "",
        password: data.password,
        role: "Admin",
        status: "Active"
      }
      console.log(item)
      var response = await fetch("https://msdskserver.onrender.com/api/user/", {
        method: "post",
        headers: {
          "content-type": "application/json",
          "authorization": sessionStorage.getItem("token")
        },
        body:JSON.stringify(item)
      })
      console.log(item)
      response = await response.json()
      if (response.result === "Fail")
        alert(response.message)
      else
        navigate("/superadmin")
    }
    else
      alert("Password and Conform Password Doesn't Match!!!")
  }
  return (
    <>
        <div className="signupForm">
          <div className="signupHeading mb-4">
            <h4>Register Form</h4>
          </div>
          <form onSubmit={postData}>
            <div className="mb-3">
              <TextField name='name' label="Name" variant='standard' fullWidth required onChange={getData} color='success' />
            </div>
            <div className="mb-3">
              <TextField type='tel' name='mobile' label="Mobile" variant='standard' fullWidth required onChange={getData} color='success' placeholder='Enter 10 Digit Mobile Number' inputProps={{ maxLength: 10, minLength: 10, pattern: "[0-9]{10}" }} />
            </div>
            <div className="mb-3">
              <TextField type='email' name='email' label="Email Address" variant='standard' fullWidth onChange={getData} color='success' placeholder='Enter Email Address'/>
            </div>
            <div className="mb-3">
              <TextField type='password' name='password' label='Password' variant='standard' fullWidth required onChange={getData} color='success' />
            </div>
            <div className="mb-3">
              <TextField type='password' name='cfrpassword' label='Conform Password' variant='standard' fullWidth required onChange={getData} color='success' />
            </div>
            <div className="mb-3">
              <Button type='submit' className='bg-success text-center w-100 text-light'>Add Admin</Button>
            </div>
            <div className="linkAccount">
              <p>Already Admin Account? <Link to="/superadmin" style={{textDecoration:"none", color:"red"}}>GO DASHBOARD</Link></p>
            </div>
          </form>
        </div>
    </>
  )
}
